<template>
  <div>
    <initial-loading :active="showInitialLoading"/>
    <div id="app" v-if="!load && empresa.status === '2'" class="android_platform lecard-go" :class="theme">
      <router-view/>
    </div>
    <status-empresa v-else-if="!load" :status="empresa.status"/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 0 32px">
          <loading :text="loadingGeral"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Loading from "../../components/Loading";
  import InitialLoading, { initialLoadingMixin } from "../../components/InitialLoading";
  import StatusEmpresa from "../../components/StatusEmpresa";

  export default {
    name: 'App',
    mixins: [initialLoadingMixin],
    components: {InitialLoading, Loading, StatusEmpresa},
    data() {
      return {
        load: true,
        theme: 'theme-1',
        empresa: { status: '2' }
      }
    },

    methods: {
      getEmpresa(dominio) {
        this.load = true;
        this.$http.get('v2/empresa', { params: { dominio } }).then(response => {
          if (response.data && response.data.empresa) {
            this.empresa = response.data.empresa;
            this.$store.commit('setEmpresa', this.empresa);
            this.setColor(this.empresa.theme_color);
            this.load = false;

          } else {
            this.load = false;

            if (this.$route.name !== 'P404') {
              this.$router.push('/404');
            }
          }

        }, res => {
          this.empresa.status = '1';
          this.load = false;
        });
      },

      setColor(color) {
        if (color) {
          document.documentElement.style.setProperty('--lecard-primary', color);
          document.documentElement.style.setProperty('--lecard-secondary', color);
        }

        document.title = `${this.empresa.nome_fantasia} | LeCard`;
      },

      initApp() {
        const dominio = (this.$route.params.id || '').toLowerCase();

        if (!this.isValidSubdomain(dominio)) {
          this.load = false;
          return;
        }

        const fullPath = this.$route.fullPath;
        const prefix = `/${dominio}`;
        const path = fullPath.startsWith(prefix)
            ? fullPath.slice(prefix.length)
            : '';

        const url = `https://${dominio}.lecard.app${path || '/'}`;
        this.$store.state.url_site = url;
        window.location.replace(url);

        setTimeout(() => {
          this.load = false;
        }, 5000)
      },

      isValidSubdomain(str) {
        if (!str) return false;

        const regex = /^[a-z0-9]+([a-z0-9-]*[a-z0-9])?$/;
        return regex.test(str);
      }
    },

    mounted() {
      console.log('Current version: ' + this.app_version);
      this.initApp();
    },

    computed: {
      loadingGeral() {
        return this.$store.state.load;
      }
    }
  }
</script>

<style>
  .init-load {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: #F6F7F8;
  }
</style>
